import { render, staticRenderFns } from "./accordion-item.vue?vue&type=template&id=11c67de8&scoped=true&"
import script from "./accordion-item.vue?vue&type=script&lang=js&"
export * from "./accordion-item.vue?vue&type=script&lang=js&"
import style0 from "./accordion-item.vue?vue&type=style&index=0&id=11c67de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c67de8",
  null
  
)

export default component.exports